import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { localUser, isTokenExpired as _isTokenExpired } from "../../assets/Helpers";
import { addUserInfo } from "../../actions/userActions";
import { logoutUser } from "../../actions/userActions";

const isTokenExpired = (token) => { try { return _isTokenExpired(token); } catch (e) { return true; } };
const AppWrapper = (props) => {
  const localUserInfo = localUser();
  const authToken = localUserInfo?.AUTHTOKEN;
  const dispatch = useDispatch();

  useEffect(() => {
    if (localUserInfo && isTokenExpired(authToken)) {
      localStorage.removeItem("BEGROSS_USER");
      localStorage.removeItem("woo-session");
      dispatch(logoutUser());
      return;
    }

    if (localUserInfo && localUserInfo.ID && authToken) {
      dispatch(
        addUserInfo({
          isLogged: true,
          id: localUserInfo.ID,
          userId: localUserInfo.ID,
          firstName: localUserInfo.firstName,
          lastName: localUserInfo.lastName,
          email: localUserInfo.email,
        })
      );
    }
  }, [localUserInfo?.ID, authToken, dispatch]);

  return <React.Fragment>{props.children}</React.Fragment>;
};

export default AppWrapper;
